/**
 * The Construction Kit (docs/spec/07 §4). `createKitScene(host, def)` opens `def` (a shared link,
 * a set cave); without one it opens the working copy from last time, or a new cave.
 */

import type { CaveDef } from '../caves/types';
import type { Scene, SceneHost } from '../ui/scene';
import { KitScene } from './ui/kitScene';

export function createKitScene(host: SceneHost, def?: CaveDef): Scene {
  return new KitScene(host, def);
}

export { KitScene };
